const monthNames = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

export function days() {
  const items: any[] = [];
  Array.from(new Array(31), (v, i) =>
    items.push({
      label: i + 1,
      value: i <= 8 ? `0${i + 1}` : i + 1,
    }),
  );
  return items;
}

export function months() {
  const items: any[] = [];
  Array.from(new Array(12), (v, i) =>
    items.push({
      label: monthNames[i],
      value: i <= 8 ? `0${i + 1}` : i + 1,
    }),
  );
  return items;
}

export function years() {
  const year = new Date().getFullYear();
  const items: any[] = [];
  Array.from(new Array(99), (v, i) =>
    items.push({
      label: year - i,
      value: year - i,
    }),
  );
  return items;
}

const now = +new Date();
let index = 0;

export function makeid(length: number) {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function getUid() {
  return `${makeid(10)}-${now}-${++index}`;
}

export function removeFileItem(data: any, fileList: any[]): any[] {
  const matchKey = data.id !== undefined ? "id" : "name";
  const removed = fileList.filter((item) => item[matchKey] !== data[matchKey]);
  if (removed.length === fileList.length) {
    return fileList;
  }
  return removed;
}

export function updateFileList(data: any, fileList: any[]) {
  const nextFileList = [...fileList];
  const fileIndex = nextFileList.findIndex(({ id }: any) => id === data.id);

  if (fileIndex === -1) {
    nextFileList.push(data);
  } else {
    nextFileList[fileIndex] = data;
  }
  return nextFileList;
}
